var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5602 10.8393L19.462 3.93751C19.7895 3.61053 19.9738 3.16682 19.9742 2.70399C19.9746 2.24116 19.7911 1.79713 19.4642 1.46957C19.1372 1.14201 18.6935 0.957761 18.2307 0.957352C17.7678 0.956943 17.3238 1.14041 16.9962 1.46739L10.0944 8.36919L3.19263 1.46739C2.86508 1.13983 2.42081 0.955811 1.95757 0.955811C1.49434 0.955811 1.05007 1.13983 0.722516 1.46739C0.394958 1.79495 0.210938 2.23921 0.210938 2.70245C0.210938 3.16568 0.394958 3.60995 0.722516 3.93751L7.62431 10.8393L0.722516 17.7411C0.394958 18.0687 0.210938 18.5129 0.210938 18.9762C0.210938 19.4394 0.394958 19.8837 0.722516 20.2112C1.05007 20.5388 1.49434 20.7228 1.95757 20.7228C2.42081 20.7228 2.86508 20.5388 3.19263 20.2112L10.0944 13.3094L16.9962 20.2112C17.3238 20.5388 17.7681 20.7228 18.2313 20.7228C18.6945 20.7228 19.1388 20.5388 19.4663 20.2112C19.7939 19.8837 19.9779 19.4394 19.9779 18.9762C19.9779 18.5129 19.7939 18.0687 19.4663 17.7411L12.5602 10.8393Z",
    fill: "#4C549E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.5adda9d4bb6e6938bf4dc9f69583e61f.svg";
export { ForwardRef as ReactComponent };